export function handleOnchange(actualValue: string[], files: string[], onChange) {
  return (event) => {
    const value = actualValue.filter(file => !files.includes(file));
    onChange([...value, ...event]);
  };
}
